export default __webpack_public_path__ + "static/media/button_point-on.cd828e32.svg";